<template>
<div class="card shadow mb-4">
  <!-- Card Header -->
  <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
    <h6 class="m-0 font-weight-bold">{{ $t('Production_not_used') }}</h6>
    <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="$t('home_tooltip_wastings')"></i>
  </div>
  <!-- End of Card Header -->

  <!-- Card Body -->
  <div class="card-body">
    <div class="container-fluid">
      <!-- Total Production -->
      <div class="row py-10 align-items-center">
          <div class="col-md-2 text-center d-none d-md-block">
            <img class="img-fluid center-block" src="../../public/icons/energy-icons/production.png">
          </div>
          <div class="col-9 col-sm-9 col-md-7">
            <span style="font-weight: 600;">{{ $t('Total_Production') }}</span>
            <span style="display:block; color:#999; overflow:hidden">
              {{ $t('Total_energy_produced') }}
              <span v-if="range =='hour'">{{ $t('in_last_hour') }}</span> 
              <span v-if="range =='day'">{{ $t('in_last_24_hours') }}</span> 
              <span v-if="range =='week'">{{ $t('in_last_7_days') }}</span> 
              <span v-if="range =='month'">{{ $t('in_last_30_days') }}</span>
            </span>
          </div>
          <div class="col-3 col-sm-3 col-md-3 text-center">
            <LoadingSpinner v-if="loading"></LoadingSpinner>
            <span v-else class="h4 mb-0 font-weight-bold text-blue">{{ total_production }}</span> 
            <span style="display:block">kWh</span>
          </div>
      </div>
      <!-- Production Used by House -->
      <div class="row py-10 align-items-center">
          <div class="col-md-2 text-center d-none d-md-block">
            <img class="img-fluid center-block" src="../../public/icons/energy-icons/production-used.png">
          </div>
          <div class="col-9 col-sm-9 col-md-7">
            <span style="font-weight: 600;">{{ $t('Production_used_House') }}</span>
            <span style="display:block; color:#999; overflow:hidden">
              {{ $t('Energy_consumed_by_house_from_production') }}
              <span v-if="range =='hour'">{{ $t('in_last_hour') }}</span> 
              <span v-if="range =='day'">{{ $t('in_last_24_hours') }}</span> 
              <span v-if="range =='week'">{{ $t('in_last_7_days') }}</span> 
              <span v-if="range =='month'">{{ $t('in_last_30_days') }}</span>
            </span>
          </div>
          <div class="col-3 col-sm-3 col-md-3 text-center">
            <LoadingSpinner v-if="loading"></LoadingSpinner>
            <span v-else class="h4 mb-0 font-weight-bold text-blue">{{ PV_House }}</span> 
            <span style="display:block">kWh</span>
          </div>
      </div>
      <!-- Production Used by Battery -->
      <div v-if="has_battery" class="row py-10 align-items-center">
        <div class="col-md-2 text-center d-none d-md-block">
          <img class="img-fluid center-block" src="../../public/icons/energy-icons/production-used.png">
        </div>
        <div class="col-9 col-sm-9 col-md-7">
          <span style="font-weight: 600;">{{ $t('Production_used_Battery') }}</span>
          <span style="display:block; color:#999; overflow:hidden">{{ $t('Energy_consumed_by_battery_from_production') }}
            <span v-if="range =='hour'">{{ $t('in_last_hour') }}</span> 
            <span v-if="range =='day'">{{ $t('in_last_24_hours') }}</span> 
            <span v-if="range =='week'">{{ $t('in_last_7_days') }}</span> 
            <span v-if="range =='month'">{{ $t('in_last_30_days') }}</span>
          </span>
        </div>
        <div class="col-3 col-sm-3 col-md-3 text-center">
          <LoadingSpinner v-if="loading"></LoadingSpinner>
          <span v-else class="h4 mb-0 font-weight-bold text-blue">{{ PV_Batt }}</span> 
          <span style="display:block">kWh</span>
        </div>
      </div>
      <!-- Production Not Used -->
      <div class="row py-10 align-items-center border-top-1">
        <div class="col-md-2 text-center d-none d-md-block">
          <img class="img-fluid center-block" src="../../public/icons/energy-icons/production-not-used.png">
        </div>
        <div class="col-9 col-sm-9 col-md-7">
          <span style="font-weight: 600;">{{ $t('Production_not_used') }}</span>
          <span style="display:block; color:#999; overflow:hidden">{{ $t('Wasted_energy') }}
            <span v-if="range =='hour'">{{ $t('in_last_hour') }}</span> 
            <span v-if="range =='day'">{{ $t('in_last_24_hours') }}</span> 
            <span v-if="range =='week'">{{ $t('in_last_7_days') }}</span> 
            <span v-if="range =='month'">{{ $t('in_last_30_days') }}</span>
          </span>
        </div>
        <div class="col-3 col-sm-3 col-md-3 text-center">
          <LoadingSpinner v-if="loading"></LoadingSpinner>
          <span v-else class="h4 mb-0 font-weight-bold text-blue">{{ PV_Grid }}</span> 
          <span style="display:block">kWh</span>
        </div>
      </div>
    </div>
  </div>
  <!-- End of Card Body -->
</div>
</template>

<script>
import friendlyFloatingPoint from '../helpers/friendlyFloatingPoint.js'
import LoadingSpinner from './LoadingSpinner.vue'

export default {
  name: 'ProductionNotUsed',
  components: {
    LoadingSpinner
  },
  computed: {
    data: function(){
      return this.$store.getters.data_wastings
    },
    total_production: function(){
      if(this.data && this.data.PV_House!=null && this.data.PV_Batt!=null && this.data.PV_Grid!=null)
        return friendlyFloatingPoint(this.data.PV_House + this.data.PV_Grid + this.data.PV_Batt)
      else return '-'
    },
    has_battery: function(){
      if (this.$store.getters.user_isAdmin) return this.$store.getters.remote_user_bess
      return this.$store.getters.user_bess
    },
    PV_Grid: function(){
      if (this.data && this.data.PV_Grid != null) return friendlyFloatingPoint(this.data.PV_Grid)
      else return '-' 
    },
    PV_House: function(){
      if (this.data && this.data.PV_House != null) return friendlyFloatingPoint(this.data.PV_House)
      else return '-'
    },
    PV_Batt: function(){
      if (this.data && this.data.PV_Batt != null) return friendlyFloatingPoint(this.data.PV_Batt)
      else return '-'
    },
    range: function(){
      return this.$store.getters.range
    },
    loading: function(){
      return this.$store.getters.data_loading
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
